/**
 * Utility to traverse a cartesian coordinate grid
 *
 */

/**
 * The zoom ranges mapped to location types.
 *
 * @return array
 */
export const zoomRanges = [
    { range: 6, location: 'country' },
    { range: 9, location: 'county' },
    { range: 14, location: 'city' },
    { range: 19, location: 'road' },
];

export default class Grid {
    /**
     * Initialize map controller.
     *
     * @param config
     * @param axios
     * @param Object map
     * @param Object filters
     *
     */
    constructor(config, axios, map, filters, callback) {
        this.config = config;
        this.axios = axios;
        this.map = map;
        this.filters = filters;
        this.callback = callback;

        this.zooms = zoomRanges;

        this.reset();
    }

    /**
     * Reset the grid & reload markers.
     */
    reset() {
        this.chunk = {};

        this.locationType = this.getLocationType();

        this.isShowReportsLevel = this.locationType === 'road' || this.locationType === 'city';

        this.setOrigin();
        this.loadChunk();
    }

    /**
     * Set the origin point as a grid reference.
     */
    setOrigin() {
        const { map } = this;

        const bounds = map.getBounds();

        const ne = bounds.getNorthEast();
        const sw = bounds.getSouthWest();

        this.origin = {
            lat1: sw.lat(),
            lat2: ne.lat(),
            lon1: sw.lng(),
            lon2: ne.lng(),
        };
    }

    /**
     * Get map bounds.
     *
     * @return Object
     */
    getBounds() {
        return this.map.getBounds();
    }

    /**
     * Get the location type based on the current zoom.
     *
     * @return String
     */
    getLocationType() {
        const { zooms } = this;

        const zoom = this.map.getZoom();

        for (let i = 0; i < zooms.length; i += 1) {
            if (zoom <= zooms[i].range) {
                return zooms[i].location;
            }
            if (zoom >= 19) {
                return 'road';
            }
        }

        return zooms[0].location;
    }

    /**
     * Load chunk bounds.
     *
     * Get object containing bounds, width and height of current chunk.
     *
     * @return Object
     */
    async loadChunk() {
        const { filters } = this;
        const { endpoints } = this.config;
        const position = this.origin;

        const route = this.isShowReportsLevel
            ? endpoints.mapReports
            : endpoints.mapCount;

        const params = {
            location_type: this.locationType,
            ...(this.isShowReportsLevel && position),
            ...(filters.type && { closed: filters.type === 'closed' ? 1 : 0 }),
            ...(filters.days && { days: filters.days }),
        };

        const getChunk = await this.axios.get(route, { params });

        if (this.isShowReportsLevel) {
            this.chunk.reports = getChunk.data.reports;
        } else {
            this.chunk.locations = getChunk.data.locations;
        }

        this.callback(this.chunk);
    }
}
